import { controls } from "../../controls";

const rp571 = {
  label: "Grouped Balance Sheet",
  pageLabel: "Grouped Balance Sheet",
  starting: true,
  url: "rp571",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [
    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2" }),
  ],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "Grouped Balance Sheet",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      fields: ["gl_balance_1"],
      subtotals: {
        by: "liability_group",
        displayIn: "gl_code_1",
        groupsOnly: false,
        location: "top",
      },
      // grandtotal: { type: "fixed", displayIn: "descn", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Liability",
        columns: [
          {
            Header: "Group",
            accessor: "liability_group",
            show:false
          },
          {
            Header: "Ledger",
            accessor: "gl_code_1",
          },
          {
            Header: "Balance",
            accessor: "gl_balance_1",
            type:"currency"
          },
        ]
      },
      {
        Header: "Assets",
        columns: [
          {
            Header: "Group",
            accessor: "asset_group",
          },
          {
            Header: "Ledger",
            accessor: "gl_code_2",
          },
          {
            Header: "Balance",
            accessor: "gl_balance_2",
            type:"currency"
          },
        ]
      }


    ]
  }
};

export default rp571;